import React from 'react';
import { PopoverChevron, PopoverContent, usePopoverContext } from '@fiverr-private/popover';
import { Text } from '@fiverr-private/typography';
import { Container, Stack } from '@fiverr-private/layout_components';
import { TextButton } from '@fiverr-private/button';
import { AppI18n } from '../../../../../i18n';
import { HowItWorksStepKey } from '../../../../types/howItWorksSteps';

interface Props {
    icon: JSX.Element;
    stepKey: HowItWorksStepKey;
    currentStep: number;
    hasPreviousStep: boolean;
    hasNextStep: boolean;
    onPrevStep: () => void;
    onNextStep: () => void;
    onAnimationEnd: () => void;
}

export const HowItWorksPopoverContent = ({
    icon,
    currentStep,
    hasPreviousStep,
    stepKey,
    hasNextStep,
    onPrevStep,
    onNextStep,
    onAnimationEnd,
}: Props) => {
    const { setOpen } = usePopoverContext();

    const handleDoneClick = () => {
        setOpen(false);
    };

    return (
        <PopoverContent disablePadding onAnimationEnd={onAnimationEnd}>
            <Stack gap="2" direction="column" padding="4">
                <Stack gap="1" direction="column">
                    <Stack justifyContent="spaceBetween">
                        <Stack gap="2">
                            {icon}
                            <Text fontWeight="bold">
                                <AppI18n k={`how_it_works.steps.${stepKey}.title`} />
                            </Text>
                        </Stack>
                        <Container
                            paddingX="1"
                            backgroundColor="blue_900"
                            borderRadius="sm"
                            maxHeight="22px"
                            width="33px"
                            textAlign="center"
                        >
                            <Text size="b_sm" fontWeight="bold" color="white">
                                {currentStep + 1}/3
                            </Text>
                        </Container>
                    </Stack>
                    <Text color="bodySecondary" maxWidth="300px">
                        <AppI18n k={`how_it_works.steps.${stepKey}.description`} />
                    </Text>
                </Stack>
                <Stack justifyContent="flexEnd" gap="10">
                    <TextButton size="sm" onClick={onPrevStep} hidden={!hasPreviousStep}>
                        <AppI18n k="how_it_works.stepper.back_button_text" />
                    </TextButton>
                    <TextButton size="sm" hidden={!hasNextStep} onClick={onNextStep}>
                        <AppI18n k="how_it_works.stepper.next_button_text" />
                    </TextButton>
                    <TextButton size="sm" hidden={hasNextStep} onClick={handleDoneClick}>
                        <AppI18n k="how_it_works.stepper.done_buton_text" />
                    </TextButton>
                </Stack>
            </Stack>
            <PopoverChevron />
        </PopoverContent>
    );
};
